"use strict";Object.defineProperty(exports, "__esModule", {value: true});// Copy for the two ways staff can text a patient: a secure text with a link
// (DELIVERY_METHOD.SECURE, MessageType.SecureSMS) and an insecure, plain text
// message (DELIVERY_METHOD.SMS, MessageType.InsecureSMS). Web and mobile both
// read it, so the wording stays the same everywhere.
//
// Never say "HIPAA compliant" here: an organisation can stay compliant while
// using plain texts if it sends no PHI. Say whether a text can contain PHI.

 const SECURE_TEXT_LABEL = 'Secure text with link'; exports.SECURE_TEXT_LABEL = SECURE_TEXT_LABEL
 const INSECURE_TEXT_LABEL = 'Insecure text'; exports.INSECURE_TEXT_LABEL = INSECURE_TEXT_LABEL
// Short form for the inbox row's pill, where the full label doesn't fit.
 const INSECURE_SHORT_LABEL = 'Insecure'; exports.INSECURE_SHORT_LABEL = INSECURE_SHORT_LABEL

 const CAN_CONTAIN_PHI = 'Can contain PHI'; exports.CAN_CONTAIN_PHI = CAN_CONTAIN_PHI
 const CANT_CONTAIN_PHI = "Can't contain PHI"; exports.CANT_CONTAIN_PHI = CANT_CONTAIN_PHI

 const MORE_INFORMATION_LABEL = 'More information'; exports.MORE_INFORMATION_LABEL = MORE_INFORMATION_LABEL

 const SECURE_BROADCAST_HINT =
  "We'll text each patient a secure link to your message. Can contain PHI."; exports.SECURE_BROADCAST_HINT = SECURE_BROADCAST_HINT
 const INSECURE_BROADCAST_HINT =
  "We'll send each patient your message as a regular text message. Can't contain PHI."; exports.INSECURE_BROADCAST_HINT = INSECURE_BROADCAST_HINT

// Leads the explainer when it opens from an insecure chat's pill or label.
 const INSECURE_CHAT_LEAD =
  "Messages in this chat are sent as regular text messages and can't contain PHI."; exports.INSECURE_CHAT_LEAD = INSECURE_CHAT_LEAD

 const INSECURE_COMPOSER_PLACEHOLDER_WEB = "Insecure text: don't include PHI"; exports.INSECURE_COMPOSER_PLACEHOLDER_WEB = INSECURE_COMPOSER_PLACEHOLDER_WEB
 const INSECURE_COMPOSER_PLACEHOLDER_MOBILE = 'Insecure text: no PHI'; exports.INSECURE_COMPOSER_PLACEHOLDER_MOBILE = INSECURE_COMPOSER_PLACEHOLDER_MOBILE

 const SECURE_TEXT_HELP_URL = 'https://www.bloomtext.com/how-to/messaging/secure-vs-insecure-texting/'; exports.SECURE_TEXT_HELP_URL = SECURE_TEXT_HELP_URL
 const SECURE_TEXT_HELP_LABEL = 'Learn more in the help center'; exports.SECURE_TEXT_HELP_LABEL = SECURE_TEXT_HELP_LABEL








 const SECURE_TEXT_EXPLAINER_TITLE = 'Secure text vs. insecure text'; exports.SECURE_TEXT_EXPLAINER_TITLE = SECURE_TEXT_EXPLAINER_TITLE

const INSECURE_TEXT_CARD = {
  kind: 'insecure',
  title: exports.INSECURE_TEXT_LABEL,
  badge: exports.CANT_CONTAIN_PHI,
  points: [
    "Your message is sent as a regular text message. The patient reads and replies in their phone's messaging app.",
    "Carriers and the patient's phone store it unencrypted.",
    'Can\'t contain PHI. Use it only for messages like "Please call our office."',
  ],
}

 const SECURE_TEXT_EXPLAINER_CARDS = [
  {
    kind: 'secure',
    title: exports.SECURE_TEXT_LABEL,
    badge: exports.CAN_CONTAIN_PHI,
    points: [
      'The patient gets a text (and an email, if we have one) saying they have a secure message, with a link.',
      'Your message stays encrypted in BloomText. The patient reads and replies there.',
      'Can contain PHI (protected health information).',
    ],
  },
  INSECURE_TEXT_CARD,
]; exports.SECURE_TEXT_EXPLAINER_CARDS = SECURE_TEXT_EXPLAINER_CARDS

// Opened from an insecure chat itself (its inbox pill or header label), the
// explainer is short: what this chat is, and what to do instead for PHI.
// More information keeps the full comparison above.
 const INSECURE_CHAT_EXPLAINER = {
  title: exports.INSECURE_TEXT_LABEL,
  badge: exports.CANT_CONTAIN_PHI,
  lead: exports.INSECURE_CHAT_LEAD,
  nextStep: 'Need to send PHI? Start a new chat with this patient and choose Secure text with link.',
}; exports.INSECURE_CHAT_EXPLAINER = INSECURE_CHAT_EXPLAINER
